import React, { createContext, useState, useContext, ReactNode } from 'react';
import { useEffect } from 'react';
import { Conversation, loadingToolsType, ToolQueueContextProps } from '../multimodal-live-types';



const ToolQueueContext = createContext<ToolQueueContextProps | undefined>(undefined);

export const ToolQueueProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [conversation, setConversation] = useState<any>([]);

    const [loadingTools, setLoadingTools] = useState<Array<loadingToolsType>>([]);


    return (
        <ToolQueueContext.Provider
            value={{
                conversation,
                loadingTools,
                setLoadingTools,
                setConversation
            }}
        >
            {children}
        </ToolQueueContext.Provider>
    );
};

export const useToolQueue = (): ToolQueueContextProps => {
    const context = useContext(ToolQueueContext);
    if (!context) {
        throw new Error('useToolQueue must be used within a ToolQueueProvider');
    }
    return context;
};
